import { Tooltip } from "@material-ui/core";
import Chip from "@material-ui/core/Chip";
import { createStyles, makeStyles } from "@material-ui/styles";
import React from "react";
import { ExamTemplateWithStructureIndex } from "../../model/Exam";
import { GetTranslatedValue } from "../../model/Shared/TranslatedValue";

type ExamChipsProps = {
  exams: ExamTemplateWithStructureIndex[];
};

const margin = 10;
const useStyles = makeStyles(() =>
  createStyles({
    container: {
      marginTop: -margin,
    },
    item: {
      marginRight: margin,
      marginTop: margin,
      maxWidth: "100%",
    },
  })
);

const ExamChips: React.FC<ExamChipsProps> = ({ exams }) => {
  const cssClasses = useStyles({});
  const examNames = exams.map((exam) => GetTranslatedValue(exam.name));
  const examElements = examNames.map((name) => (
    <Tooltip title={name} key={name}>
      <Chip component="span" className={cssClasses.item} label={name} />
    </Tooltip>
  ));
  return <div className={cssClasses.container}>{examElements}</div>;
};

export default ExamChips;
